import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DashboardComponent } from './dashboard.component';
import { ListCheckinComponent } from './list-checkin/list-checkin.component';
import { GraphCheckOuttimeComponent } from './graph-check-outtime/graph-check-outtime.component';
import { GraphForgotCheckComponent } from './graph-forgot-check/graph-forgot-check.component';
import { Daterangepicker } from 'ng2-daterangepicker';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    Daterangepicker,
    ReactiveFormsModule,
  ],
  declarations: [DashboardComponent, ListCheckinComponent, GraphCheckOuttimeComponent, GraphForgotCheckComponent],
  exports: [
    DashboardComponent
  ],
  providers: [
  ]
})
export class DashboardModule { }
